import React from 'react';
import ActionButton from './ActionButton';

const MarkTypeButton = ({ contactId, type, className, title, Icon, onMark }) => {
  const handleClick = (e) => {
    e.stopPropagation();
    onMark(contactId, type, e);
  };

  return (
    <ActionButton
      icon={Icon}
      onClick={handleClick}
      className={className}
      title={title}
    />
  );
};

export default MarkTypeButton;
